
import { Vue, Component, Prop } from 'vue-property-decorator';
import Draggable from 'vuedraggable';

@Component({
  components: {
    Draggable,
  },
})
export default class FirstStep extends Vue {
  @Prop({
    type: Array,
    default: [],
  }) questionArray!: any;

  private question: any = []

  mounted() {
    this.question = this.questionArray.sort((a: any, b: any) => a.sort - b.sort);
  }

  getSort(): Array<{ id: string, sort: number }> {
    return this.question.map((item: any, index: number) => ({ id: item.id || '', sort: index }));
  }
}
